<div class="container">
    @if (showLoading()) {
        <div class="mask">
            <i class="spinner"></i>
            <h2>{{ call.description }}</h2>
        </div>
    }
</div>
